import { render, staticRenderFns } from "./BasicMultiSelect.vue?vue&type=template&id=2ac74be8&scoped=true&"
import script from "./BasicMultiSelect.vue?vue&type=script&lang=js&"
export * from "./BasicMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./BasicMultiSelect.vue?vue&type=style&index=0&id=2ac74be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac74be8",
  null
  
)

export default component.exports